/* ============================================================
   YATE — Sticky Add-to-Cart (Mobile)

   Prinzip: Diese Bar dupliziert KEINE Kauflogik. Sie klickt den
   nativen Dawn-Button — Cart-Drawer, Fehlerhandling und Varianten-
   Logik bleiben zu 100 % Theme-Standard. Dadurch bleibt der Code
   update-sicher und kann keinen abweichenden Warenkorb-Zustand
   erzeugen.

   Verhalten:
   - Bar erscheint, sobald der native Add-to-Cart-Button nach oben
     aus dem Viewport gescrollt ist (nicht beim Seitenstart).
   - Preis + Verfügbarkeit werden vom nativen DOM gespiegelt
     (MutationObserver) — funktioniert auch nach Dawns Section-
     Re-Rendering bei Variantenwechsel.
   ============================================================ */

(function () {
  'use strict';

  function initBar(bar) {
    var sectionId = bar.getAttribute('data-section-id');
    if (!sectionId) return;

    var barBtn = bar.querySelector('[data-yate-satc-button]');
    var barPrice = bar.querySelector('[data-yate-satc-price]');
    var io = null;
    var nativeBtn = null;

    function queryNativeBtn() {
      return document.getElementById('ProductSubmitButton-' + sectionId);
    }

    function queryPriceEl() {
      return document.getElementById('price-' + sectionId);
    }

    /* Preis aus Dawns Preis-Container spiegeln (Sale-Preis hat Vorrang). */
    function syncPrice() {
      if (!barPrice) return;
      var priceEl = queryPriceEl();
      if (!priceEl) return;
      var item =
        priceEl.querySelector('.price__sale .price-item--sale') ||
        priceEl.querySelector('.price__regular .price-item--regular') ||
        priceEl.querySelector('.price-item');
      if (item) barPrice.textContent = item.textContent.trim();
    }

    /* Verfügbarkeit vom nativen Button spiegeln. */
    function syncAvailability() {
      if (!barBtn || !nativeBtn) return;
      var disabled = nativeBtn.hasAttribute('disabled');
      barBtn.disabled = disabled;
      barBtn.textContent = disabled ? 'SOLD OUT' : 'ADD TO BAG';
    }

    /* Sichtbarkeit: Bar zeigen, wenn der native Button oberhalb des
       Viewports verschwunden ist. rect.top < 0 verhindert, dass die
       Bar beim Laden erscheint, solange der Button noch UNTER der
       Falz liegt. */
    function observeVisibility() {
      if (io) io.disconnect();
      if (!nativeBtn || !('IntersectionObserver' in window)) return;
      io = new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          var scrolledPast =
            !entry.isIntersecting && entry.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', scrolledPast);
          bar.setAttribute('aria-hidden', scrolledPast ? 'false' : 'true');
        },
        { threshold: 0 }
      );
      io.observe(nativeBtn);
    }

    function bindNativeBtn() {
      var current = queryNativeBtn();
      if (current !== nativeBtn) {
        nativeBtn = current;
        observeVisibility();
      }
      syncAvailability();
      syncPrice();
    }

    /* Klick: nativen Button auslösen — komplette Dawn-Logik inklusive
       Cart-Drawer läuft unverändert. */
    if (barBtn) {
      barBtn.addEventListener('click', function () {
        if (nativeBtn && !nativeBtn.hasAttribute('disabled')) {
          nativeBtn.click();
        }
      });
    }

    /* Dawn re-rendert Teile der Section bei Variantenwechsel.
       Ein debounced MutationObserver auf der Section hält Referenzen,
       Preis und Verfügbarkeit synchron — ohne Kopplung an interne
       Dawn-Events. */
    var root =
      document.getElementById('MainProduct-' + sectionId) || document.body;
    var debounce = null;
    var mo = new MutationObserver(function () {
      clearTimeout(debounce);
      debounce = setTimeout(bindNativeBtn, 120);
    });
    mo.observe(root, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['disabled'],
      characterData: true
    });

    bindNativeBtn();
  }

  function initAll() {
    document.querySelectorAll('.yate-satc').forEach(initBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
